<template>
  <div>
    <section class="section is-title-bar">
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <ul>
              <li>Réservations</li>
            </ul>
          </div>
        </div>
        <div class="level-right">
          <div class="level-item">
            <div class="buttons is-right">
              <router-link to="/reservations/ajouter" class="button is-primary">
                <span class="icon"><plus-icon /></span>
                <span>Ajouter</span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section is-main-section">
      <div class="card has-table" v-if="bookings.length >= 1">
        <div class="card-content">
          <div class="b-table has-pagination">
            <div class="table-wrapper has-mobile-cards">
              <table
                class="table is-fullwidth is-striped is-hoverable is-fullwidth"
              >
                <thead>
                  <tr>
                    <th class="is-checkbox-cell">
                      <label class="b-checkbox checkbox">
                        <input type="checkbox" value="false" />
                        <span class="check"></span>
                      </label>
                    </th>
                    <th>Date</th>
                    <th>Nom de la réservation</th>
                    <th>Checkin</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="booking in bookings.sort(
                      (a, b) => new Date(b.date) - new Date(a.date)
                    )"
                    v-bind:key="booking._id"
                  >
                    <td class="is-checkbox-cell">
                      <label class="b-checkbox checkbox">
                        <input type="checkbox" value="false" />
                        <span class="check"></span>
                      </label>
                    </td>

                    <td data-label="Date">
                      {{ formatDate(booking.date) }}
                    </td>

                    <td data-label="Nom">
                      {{ booking.name }}
                    </td>
                    <td data-label="Nom">
                      <button
                        v-if="!booking.checkin"
                        class="button is-small"
                        @click="checkIn(booking._id)"
                      >
                        Marquer comme arrivés
                      </button>
                      <div class="tag is-success" v-else>Validés</div>
                    </td>
                    <td class="is-actions-cell">
                      <div class="buttons is-right">
                        <router-link
                          :to="{ name: 'booking', params: { id: booking._id } }"
                        >
                          <button
                            class="button is-small is-primary"
                            type="button"
                          >
                            <span class="icon"><eye-icon /></span></button
                        ></router-link>
                        <DeleteButton @confirm="removebooking(booking._id)" />
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div class="card has-table" v-if="bookings.length === 0">
        <div class="card-content">
          <section class="section">
            <div class="content has-text-grey has-text-centered">
              <p>
                <span class="icon is-large"
                  ><i class="mdi mdi-emoticon-sad mdi-48px"></i
                ></span>
              </p>
              <p v-if="!loading">Aucune réservation</p>
              <p v-else>Chargement en cours...</p>
            </div>
          </section>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import axios from "axios";
import DeleteButton from "../components/DeleteButton.vue";

export default {
  data() {
    return {
      loading: true,
      bookings: [],
    };
  },
  components: { DeleteButton },
  computed: {
    formatDate() {
      return (d) => {
        let da = new Date(d);
        return da.toLocaleDateString("fr-FR");
      };
    },
  },
  methods: {
    async removebooking(id) {
      const resp = await axios.post(
        this.URL_API_SERVER + "/admin/bookings/remove",
        {
          id,
        }
      );
      if (resp.status === 200 && resp.data.result === "ok") {
        this.$router.go();
      }
    },
    async checkIn(id) {
      const resp = await axios.post(
        this.URL_API_SERVER + "/admin/bookings/checkin",
        {
          id,
        }
      );
      if (resp.status === 200 && resp.data.result === "ok") {
        this.$router.go();
      }
    },
  },
  created() {
    const fetchData = async () => {
      const { data: resp } = await axios.get(
        this.URL_API_SERVER + "/admin/bookings/all"
      );
      this.loading = false;
      this.bookings = resp.bookings;
    };

    fetchData();
  },
};
</script>
